<template>
    <PageFrameContainer>
        <div v-if="orderAccepted">
            <h1>
                Your order has been sent for processing. We will contact You as soon as possible!
            </h1>
        </div>
        <div class="bank-transfer-container" v-else>
            <h2>
                Bank transfer
            </h2>

            <div class="products-table">
                <p class="header">Product Name</p>
                <p class="header">Quantity</p>
                <p class="header">Unit Price</p>
                <p class="header">Total</p>

                <template v-for="product in Object.keys(cart)">
                    <div class="versions-track" :key="`${product}-track`"></div>
                    <router-link :to="{ name: resolveLink(product), params: {productId: product} }" class="product-name"
                                 :key="product">{{product|productLicenseTypeFilterWithKey}}
                    </router-link>
                    <p :key="`${product}-qty`">
                        {{cart[product]}}
                    </p>
                    <p :key="`${product}-price`">$ {{pricePerUnit(product)}}</p>
                    <p :key="`${product}-total`">$ {{totalUnitsPrice(product,cart[product])}}</p>
                </template>
            </div>
            <div class="total-table">
                <p>Sub-Total:</p>
                <p>$ {{subTotalPrice()}}</p>
                <div class="versions-track"></div>
                <p class="total">Total:</p>
                <p class="total">$ {{totalPrice()}}</p>
            </div>
            <div class="bank-transfer-instructions">
                <h2>
                    Bank Transfer Instructions
                </h2>
                <p class="header">
                    Please transfer the total amount to the following bank account.
                </p>
                <div class="bank-transfer-table">
                    <p>
                        After making the purchase, the invoice will be sent to the email address provided during
                        registration. Pay the bill in a way convenient for you. The invoice for payment is valid for
                        three banking days. After receiving the payment, the electronic license keys you purchased will
                        be sent to the email address provided during registration.
                    </p>
                    <p>
                        Your order will not ship until we receive payment.
                    </p>
                </div>
            </div>
            <Loader v-if="submitting === true">Sending ...</Loader>
            <div v-else class="contact-page-container">
                <div class="contact-form">
                    <label for="firstName">*First Name</label>
                    <input type="text" id="firstName" v-model="firstName" placeholder="Enter your firstname"/>

                    <label for="lastName">*Last Name</label>
                    <input type="text" id="lastName" v-model="lastName" placeholder="Enter your lastname"/>

                    <label for="address">*Address</label>
                    <input type="text" id="address" v-model="address" placeholder="Enter your address"/>

                    <label for="postCode">*Post Code</label>
                    <input type="text" id="postCode" v-model="postCode" placeholder="Enter your post code"/>

                    <p>*Country</p>
                    <!-- <input type="text" id="country" v-model="country" placeholder="Enter your country"/>-->
                    <country-select class="country" v-model="country" :country="country" topCountry="US"
                                    :countryName="true"
                                    placeholder="Enter your country"></country-select>

                    <p>*Region / State</p>
                    <!--<input type="text" id="region" v-model="region" placeholder="Enter your region"/>-->
                    <region-select class="region" v-model="region" :country="country" :region="region"
                                   :countryName="true" :regionName="true"
                                   placeholder="Enter your region"></region-select>

                    <label for="email">*Email</label>
                    <input type="text" id="email" v-model="userEmail" placeholder="Enter your email"/>

                    <label for="message">Details</label>
                    <textarea id="message" v-model="message"
                              placeholder="Enter your order details if you need"></textarea>
                    <p>{{response}}</p>
                    <div>
                        <input id="agree" type="checkbox" v-model="agree">
                        <label for="agree">I agree with
                            <router-link class="router-link-terms" title="terms" tag="a"
                                         :to="{ name: 'termsAndConditions'}">
                                terms and conditions and privacy policy&nbsp;&rarr;
                            </router-link>
                        </label>
                    </div>
                    <p>{{response}}</p>
                    <button v-if="validateInfo() && agree" v-on:click="send">Send</button>
                    <div class="not-valid-order" v-else>
                        <p>{{validateInfoMessage}}</p>
                        <button class="confirm-not-active">
                            Send
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </PageFrameContainer>
</template>

<script>
    import PageFrameContainer from "../../../components/PageFrameContainer";
    import Loader from "../../../components/Loader";

    export default {
        name: "BankTransferPage",
        components: {PageFrameContainer, Loader},
        props: {
            firstName: String,
            lastName: String,
            address: String,
            postCode: String,
            country: String,
            region: String,
            userEmail: String,
            message: String,
            submitting: Boolean,
            response: String,
            validateInfoMessage: String,
            orderAccepted: Boolean
        },
        data: function () {
            return {
                agree: false
            }
        },
        computed: {
            cart() {
                return this.$store.state.cart;
            }
        },
        mounted: function () {

            this.orderAccepted = false;
        },
        methods: {
            addToCart() {
                console.info(`add to cart: ${this.productId}, 1`);
                this.$store.commit('addToCart', {product: this.productId, qty: 1});
            },
            pricePerUnit(_product) {
                return this.$prices.getProductPrice(_product, 'annualy');
            },
            totalUnitsPrice(_product, _qty) {
                return _qty * this.pricePerUnit(_product);
            },
            subTotalPrice() {
                return this.totalPrice();
            },
            totalPrice() {
                let cart = this.$store.state.cart;
                let products = Object.keys(cart);
                let totalQty = 0;
                for (let x of products)
                    totalQty += cart[x] * this.pricePerUnit(x);
                return totalQty;
            },
            validateInfo() {
                if (this.firstName == null || this.firstName == undefined || this.firstName === "") {
                    this.validateInfoMessage = "Firstname not valid!";
                    return false;
                }
                if (this.lastName == null || this.lastName == undefined || this.lastName === "") {
                    this.validateInfoMessage = "Lastname not valid!";
                    return false;
                }
                if (this.address == null || this.address == undefined || this.address === "") {
                    this.validateInfoMessage = "Address not valid!";
                    return false;
                }
                if (this.postCode == null || this.postCode == undefined || this.postCode === "") {
                    this.validateInfoMessage = "PostCode not valid!";
                    return false;
                }
                if (this.country == null || this.country == undefined || this.country === "") {
                    this.validateInfoMessage = "Country not valid!";
                    return false;
                }
                if (this.region == null || this.region == undefined || this.region === "") {
                    this.validateInfoMessage = "Region not valid!";
                    return false;
                }
                if (this.userEmail == null || this.userEmail == undefined || this.userEmail === "" || !this.userEmail.includes("@")) {
                    this.validateInfoMessage = "User e-mail not valid!";
                    return false;
                }
                if (!this.agree) {
                    this.validateInfoMessage = "Accept our privacy policy!";
                    return false;
                }

                return true;
            },
            resolveLink(_product) {
                switch (_product.toLowerCase()) {
                    case 'bw1start':
                        return 'pricingStart';
                    case 'bw1standard':
                        return 'pricingStandard';
                    case 'bw1power':
                        return 'pricingPower';
                }
            },
            async send() {
                if (!this.validateInfo())
                    return;
                this.submitting = true;
                try {
                    let cart = this.$store.state.cart;
                    let products = Object.keys(cart);
                    let totalDesc = `Customer info:
-----------------------------------------------------------
First Name: ${this.firstName}
Last Name: ${this.lastName}
Address: ${this.address}
Post Code: ${this.postCode}
Country: ${this.country}
Region: ${this.region}\n

Products info:
-----------------------------------------------------------\n`;
                    for (let prod of products) {
                        totalDesc += `Product: ${prod} | Qty: ${cart[prod]} | Cost: ${this.pricePerUnit(prod)}$ | SubTotal: ${this.totalUnitsPrice(prod, cart[prod])}$\n`;
                    }
                    totalDesc += `
-----------------------------------------------------------
\nTotal: ${this.totalPrice()}$\n

Description:
-----------------------------------------------------------\n`

                    const formData = new FormData();
                    formData.append('name', this.firstName);
                    formData.append('email', this.userEmail);
                    formData.append('text', `${totalDesc}\n${this.message}`);

                    let response = await window.fetch(`${window.oneblendingHostApi}/invoice-request/post`, {
                        method: 'POST',
                        mode: 'cors',
                        body: formData
                    });

                    if (response.status === 200) {
                        let data = await response.json();
                        this.firstName = "";
                        this.lastName = "";
                        this.address = "";
                        this.postCode = "";
                        this.country = "";
                        this.region = "";
                        this.response = `Message sent. Registered # ${data.id}`;

                        await setTimeout(() => {
                            this.orderAccepted = true;
                        }, 2000);
                        console.info(`reset cart`);
                        this.$store.commit('resetCart');

                    } else if (response.status !== 200) {

                        this.response = "Message not sent. Try again later"

                    }
                } finally {
                    this.submitting = false;
                }

            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../../theme/theme";

    h1 {
        margin-top: 4rem;
    }

    h2 {
        font-weight: 300;
        font-size: 2em;
        color: $primary20;
    }

    .bank-transfer-container {
        display: grid;
        grid-template-rows: repeat(5, auto);
        margin-top: 2rem;

        .products-table {
            display: grid;
            grid-template-columns: repeat(4, auto);
            border: 1px solid $text40;
            border-radius: 0.3rem;
            margin-top: 2rem;

            p {
                text-align: center;
                font-weight: 300;
                font-size: 1rem;
                align-self: center;
                justify-self: center;
                padding-bottom: 1rem;
                padding-top: 1rem;
            }

            .product-name {
                font-weight: 400;
                font-size: 1rem;
                color: $primary20;
                align-self: center;
                justify-self: center;
            }

            .header {
                font-weight: 400;

            }

            img {
                justify-self: center;
                max-height: 8rem;
            }

            .versions-track {
                margin-bottom: 0;
                border-bottom: 1px solid $text20;
                z-index: -1;
                grid-column: 1/-1;
            }

            a {
                text-decoration: none;
                text-effect: none;
                font-size: 1.3em;
                color: $primary20;
                text-align: center;
                margin-left: 1rem;
                margin-right: 1rem;
            }

            a:hover {
                color: $primary80;
            }
        }

        .total-table {
            display: grid;
            grid-template-columns: auto auto;
            grid-template-rows: auto auto;
            justify-self: end;
            column-gap: 2rem;
            border: 1px solid $text20;
            border-radius: 0.2rem;
            margin-top: 2rem;

            p {
                border-right: 1px solid $text20;
                padding-right: 2rem;
                padding-left: 0.5rem;
                height: 2rem;
                padding-top: 0.4rem;
                font-size: 1.2rem;
            }

            .total {
                font-size: 1.4rem;
                font-weight: 400;
            }

            .versions-track {
                margin-bottom: 0;
                border-bottom: 1px solid $text20;
                z-index: -1;
                grid-column: 1/-1;
            }
        }

        .bank-transfer-instructions {
            display: grid;

            h2 {
                margin-bottom: 1rem;
            }

            p.header {
                font-size: 1rem;
                font-weight: 400;
                margin-bottom: 1rem;
            }

            .bank-transfer-table {
                border: 1px solid $text80;
                border-radius: 0.2rem;
                background: $back40;
                padding: 0.5rem;
                display: grid;
            }

            p {
                font-size: 1rem;
                font-weight: 300;
            }
        }

        .contact-page-container {
            .contact-form {
                padding-top: 1em;
                display: grid;
                grid-gap: 0.6em;
                align-self: start;
                max-width: 30em;
                margin-left: auto;
                margin-right: auto;

                label {
                    color: $text80;
                    font-size: 1rem;
                }

                .country, .region {
                    padding: 0.2em 0.6em;
                    height: 1.8rem;
                    font-weight: 400;
                    font-size: 1rem;
                    border-width: 1px;
                    border-color: $text40;
                    background-color: $back20;
                    color: $text100;
                    border-style: solid;
                    border-radius: 0.3em;
                }

                input {
                    padding: 0.2em 0.6em;
                    font-size: 1.1rem;
                    border-width: 1px;
                    border-color: $text40;
                    background-color: $back20;
                    color: $text100;
                    border-style: solid;
                    border-radius: 0.3em;
                }

                input::placeholder {
                    font-size: 0.8rem;
                    color: $text40;
                }

                input:focus {
                    border-color: $primary60;
                    outline: none;
                }

                .input-container {
                    display: grid;
                    row-gap: 0.6rem;
                }

                textarea {
                    padding: 0.2em 0.6em;
                    font-size: 1rem;
                    border-width: 1px;
                    border-color: $text40;
                    background-color: $back20;
                    color: $text100;
                    border-style: solid;
                    border-radius: 0.3em;
                    height: 6em;
                }

                textarea:focus {
                    border-color: $primary60;
                    outline: none;
                }

                > button {
                    margin-right: 1em;
                    padding: 0.7em 2em;
                    background: $primary20;
                    border-radius: 0.4em;
                    border-color: $back20;
                    border-width: 1px;
                    text-decoration: none;
                    text-effect: none;
                    font-size: 1em;
                    align-self: center;
                    justify-self: right;
                    cursor: pointer;
                    color: $primaryText100;
                    transition: all .25s;
                    margin-bottom: 0.9rem;
                    margin-top: 1.6rem;
                    outline: none;
                }

                button:hover {
                    background: $primary100;
                }

                a {
                    font-size: 0.9em;
                    color: $text100;
                    text-decoration: none;
                    text-effect: none;
                    cursor: pointer;
                    margin-top: 0.5rem;
                    margin-right: 3rem;
                    border-bottom: 1px solid $primaryText100;
                }

                a:hover {
                    //background: $primary40;
                    border-bottom: 1px solid $text60;
                    color: $text80;
                }

                .not-valid-order {
                    justify-self: right;
                    justify-content: center;
                    display: grid;
                    margin-right: 1em;
                    margin-bottom: 1rem;

                    button.confirm-not-active {
                        padding: 0.7em 2em;
                        background: $back60;
                        border: 0;
                        text-decoration: none;
                        border-radius: 0.4rem;
                        text-effect: none;
                        font-size: 1em;
                        align-self: center;
                        justify-self: right;
                        cursor: pointer;
                        color: $primaryText100;
                        transition: all .25s;
                        outline: none;
                    }

                    p {
                        align-self: center;
                        justify-self: center;
                        color: $error;
                        margin-bottom: 0.5rem;
                        font-size: 0.8rem;
                    }


                }

                input[type=checkbox] {
                    margin-right: 0.5rem;
                    justify-self: center;
                }
            }
        }
    }
</style>